var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxiUserSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 8,
    r: 8,
    fill: "#5A5A5A",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.464844 27.6125C2.01257 22.0754 7.26302 18 13.5019 18C19.5577 18 24.6822 21.8397 26.3932 27.1287C22.8374 30.1579 18.2028 31.9902 13.1341 31.9902C8.34111 31.9902 3.93637 30.3519 0.464844 27.6125Z",
    fill: "#5A5A5A",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxiUserSymbol);
export default __webpack_public_path__ + "static/media/axiUserSymbol.0c2a837f2ed4dfb9751b8478d932182f.svg";
export { ForwardRef as ReactComponent };